
const AboutSection= () => {
  return (
    <section id="about" className="py-24 bg-[#080808] relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold/5 rounded-full blur-[100px] -mr-48 -mt-48"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gold/5 rounded-full blur-[100px] -ml-48 -mb-48"></div>

      <div className="container mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          <div className="flex-1 relative">
            <div className="relative z-10 rounded-2xl overflow-hidden border border-white/10 shadow-2xl">
              <img 
                src="https://sunriseindia.co.in/temp/images/21.jpg" 
                alt="Product in setting" 
                className="w-full h-auto"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-8 -right-8 bg-gold p-8 rounded-full shadow-2xl z-20 flex flex-col items-center justify-center w-40 h-40 transform rotate-12">
              <span className="text-black font-bold text-4xl leading-none">20+</span>
              <span className="text-black text-[10px] font-bold uppercase tracking-tighter text-center mt-1">Years of Tradition</span>
            </div>
          </div>

          <div className="flex-1">
            <h2 className="text-gold font-bold tracking-[0.3em] uppercase mb-4">Our Philosophy</h2>
            <h3 className="text-4xl md:text-5xl font-serif text-white mb-6 leading-tight">
              Bridging Ancient Traditions with <span className="text-gold">Modern Science</span>
            </h3>
            <p className="text-gray-400 mb-8 leading-relaxed">
              At Arvind Mera Sathi, we believe that true vitality comes from the earth. Our formulas are rooted in the 5,000-year-old wisdom of Ayurveda, carefully balanced with modern extraction techniques to ensure maximum potency and safety.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mb-10">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 rounded-lg glass flex items-center justify-center text-gold shrink-0">
                  <i className="fas fa-seedling text-xl"></i>
                </div>
                <div>
                  <h4 className="text-white font-bold mb-1">Ethically Sourced</h4>
                  <p className="text-gray-500 text-sm">Finest herbs collected from the Himalayas and dense Indian forests.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 rounded-lg glass flex items-center justify-center text-gold shrink-0">
                  <i className="fas fa-microscope text-xl"></i>
                </div>
                <div>
                  <h4 className="text-white font-bold mb-1">Modern Purity</h4>
                  <p className="text-gray-500 text-sm">Rigorous laboratory testing for every batch produced.</p>
                </div>
              </div>
            </div>

            <button className="px-8 py-4 bg-white text-black font-bold uppercase tracking-widest hover:bg-gold transition-all">
              Discover Our Process
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
